import { aboutInfo } from '@/mocks/about';

export default function AboutHero() {
  return (
    <section className="relative w-full pt-24 pb-12 md:pt-28 md:pb-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Breadcrumb */}
        <nav aria-label="面包屑导航" className="mb-6">
          <ol className="flex items-center gap-2 text-sm text-foreground-400">
            <li>
              <a href="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">
                首页
              </a>
            </li>
            <li>
              <i className="ri-arrow-right-s-line text-xs"></i>
            </li>
            <li>
              <span className="text-foreground-700 font-medium">关于我们</span>
            </li>
          </ol>
        </nav>

        <div className="max-w-3xl">
          <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
            {aboutInfo.tagline}
          </h1>
          <p className="text-foreground-600 text-sm md:text-base mt-4 leading-relaxed max-w-2xl">
            {aboutInfo.description}
          </p>
        </div>
      </div>
    </section>
  );
}